var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#E1E7F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5639 18.4116C21.6162 18.4116 24.1113 15.9165 24.1113 12.8643C24.1113 9.81198 21.6162 7.31689 18.5639 7.31689C15.5116 7.31689 13.0166 9.81198 13.0166 12.8643C13.0166 15.9165 15.5117 18.4116 18.5639 18.4116Z",
    fill: "#7C8DB5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0841 22.8445C27.9388 22.4812 27.745 22.142 27.527 21.8271C26.4126 20.1798 24.6928 19.0898 22.7548 18.8233C22.5126 18.7991 22.2461 18.8475 22.0523 18.9928C21.0349 19.7438 19.8237 20.1314 18.564 20.1314C17.3043 20.1314 16.0931 19.7438 15.0757 18.9928C14.8819 18.8475 14.6154 18.7748 14.3732 18.8233C12.4352 19.0898 10.6911 20.1798 9.60102 21.8271C9.383 22.142 9.18919 22.5054 9.04388 22.8445C8.97122 22.9899 8.99542 23.1595 9.06808 23.3048C9.26189 23.6439 9.50411 23.9831 9.72213 24.2738C10.0613 24.7341 10.4246 25.1459 10.8365 25.5334C11.1756 25.8726 11.5632 26.1875 11.9508 26.5024C13.8645 27.9317 16.1658 28.6826 18.5398 28.6826C20.9138 28.6826 23.2151 27.9316 25.1288 26.5024C25.5164 26.2117 25.904 25.8726 26.2431 25.5334C26.6307 25.1459 27.0183 24.734 27.3575 24.2738C27.5997 23.9589 27.8177 23.6439 28.0115 23.3048C28.1326 23.1595 28.1568 22.9899 28.0841 22.8445Z",
    fill: "#7C8DB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileAvatar);
export default __webpack_public_path__ + "static/media/profileAvatar.d39fbdd0dc6742353f0bea187008db1b.svg";
export { ForwardRef as ReactComponent };